import React, { useState, useEffect } from 'react';
import { Pressable } from 'react-native';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import styles from './Checkbox.jss';

/**
 * @typedef {{ top: number, bottom: number, left: number, right: number }} HitSlop
 * @typedef {{ onPress: (c: boolean) => void; style: Object, whiteCheckMark: boolean, hitSlop: HitSlop }} Props
 * @param {Props} props
 */
const Checkbox = ({ style, onPress, whiteCheckMark, hitSlop, checked }) => {
    const [isChecked, setChecked] = useState(checked);

    useEffect(() => {
        setChecked(checked);
    }, [checked]);

    return (
        <Pressable
            style={[styles.container, style]}
            hitSlop={hitSlop}
            onPress={() => {
                setChecked(!isChecked);
                if (typeof onPress === 'function') {
                    onPress(!isChecked);
                }
            }}
        >
            {isChecked && (
                <Icon
                    disabled
                    style={styles.icon}
                    name={whiteCheckMark ? 'checkmark' : 'confirm'}
                />
            )}
        </Pressable>
    );
};

Checkbox.propTypes = {
    style: PropTypes.shape({}),
    onPress: PropTypes.func,
    whiteCheckMark: PropTypes.bool,
    hitSlop: PropTypes.shape({}),
    checked: PropTypes.bool
};

Checkbox.defaultProps = {
    style: {},
    onPress: () => {},
    whiteCheckMark: false,
    hitSlop: { top: 0, bottom: 0, right: 0, left: 0 },
    checked: false
};

export default Checkbox;
